import Home from "./pages/home";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Blog from "./pages/blog";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Charts from "./pages/charts";
import SingleChartPage from "./pages/singleChartPage";
import SinglePostPage from "./pages/SinglePostPage";
import MainLayout from "./components/global/mainLayout";


import { firebaseConfig } from "./firebase";
import { PostList, PostShow, PostCreate, PostEdit } from "./controlPanel/posts";
import { FaqList, FaqShow, FaqCreate, FaqEdit } from "./controlPanel/faqs";
import { AdList, AdShow, AdCreate, AdEdit } from "./controlPanel/Ads";
import { ChartsList, ChartsShow, ChartsCreate, ChartsEdit } from "./controlPanel/charts";
import { CategoryList, CategoryShow, CategoryCreate, CategoryEdit } from "./controlPanel/category";
import CustomLoginPage from "./controlPanel/CustomLoginPage";

import { Admin, Resource } from "react-admin";
import {
  FirebaseDataProvider,
  FirebaseAuthProvider,
} from "react-admin-firebase";

function App() {
  const options = {
    logging: true,
    rootRef: "blogs/blog",
  };
  const dataProvider = FirebaseDataProvider(firebaseConfig, options);
  const authProvider = FirebaseAuthProvider(firebaseConfig, options);

  return (
    <Router>
      <div className="App">
        <main>
          <Switch>
            <Route path="/admin">
              <Switch>
                <Route exact path="/admin">
                  <Admin
                    loginPage={CustomLoginPage}
                    dataProvider={dataProvider}
                    authProvider={authProvider}
                  >
                    <Resource
                      name="posts"
                      list={PostList}
                      show={PostShow}
                      create={PostCreate}
                      edit={PostEdit}
                    />
                    <Resource
                      name="Category"
                      list={CategoryList}
                      show={CategoryShow}
                      create={CategoryCreate}
                      edit={CategoryEdit}
                    />
                    <Resource
                      name="Charts"
                      list={ChartsList}
                      show={ChartsShow}
                      create={ChartsCreate}
                      edit={ChartsEdit}
                    />
                    <Resource
                      name="AD"
                      list={AdList}
                      show={AdShow}
                      create={AdCreate}
                      edit={AdEdit}
                    />
                    <Resource
                      name="FAQ"
                      list={FaqList}
                      show={FaqShow}
                      create={FaqCreate}
                      edit={FaqEdit}
                    />
                  </Admin>
                </Route>
              </Switch>
            </Route>
            <Route path="/">
              <MainLayout>
                <Switch>
                  <Route exact path="/">
                    <Home />
                  </Route>
                  <Route exact path="/Blog">
                    <Blog />
                  </Route>
                  <Route exact path="/Charts">
                    <Charts />
                  </Route>
                  <Route exact path="/About">
                    <About />
                  </Route>
                  <Route exact path="/FAQ">
                    <FAQ />
                  </Route>
                  <Route exact path="/Charts/:id">
                    <SingleChartPage />
                  </Route>
                  <Route exact path="/Blogs/:id">
                    <SinglePostPage />
                  </Route>
                </Switch>
              </MainLayout>
            </Route>
          </Switch>
        </main>
      </div>
    </Router>
  );
}

export default App;
